import { inject } from 'mobx-react';
import {
    Typography,
    styled
} from '@mui/material';
import ReferencesPanel from '@extensions/components/core/ReferencesPanel';
import { DatasetResult as DapDatasetResult } from '@dapclient/components/dataset-search/DatasetResult';
import Dataset from '@extensions/models/Dataset';
import CardExpansionPanel from '@extensions/components/core/CardExpansionPanel';

const StyledSubHeaderTypography = styled(Typography)(({ theme }) => ({
    '& mark': {
        background: `${theme.palette.highlight.main}`,
    },
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1rem',
    paddingLeft: theme.spacing(2),
}));

const StyledCardExpansionPanel = styled(CardExpansionPanel)(({ theme }) => ({
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
}));

export class DatasetResult extends DapDatasetResult {
    renderReferencesPanel(dataset: Dataset) {
        if (dataset) {
            return (
                <StyledCardExpansionPanel
                    detailsId={`${dataset.name}-references`}
                    summaryContent={
                        <StyledSubHeaderTypography
                            variant="h4"
                        >
                            References
                        </StyledSubHeaderTypography>
                    }
                    detailsContent={
                        <ReferencesPanel dataset={dataset} styleAdjust />
                    }
                />
            )
        }
        return null;
    }
}

export default inject((store: any) => ({
    // TODO: Put any services you need here
    // EXAMPLE => metricsService: store.metricsService
}))(DatasetResult);
